import React from 'react'

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch (error, info) {
    // Display fallback UI
    this.setState({ hasError: true })

    console.error(error)
    // TODO: send error to reporting service
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className='error-boundary'>
        <h1>ERROR</h1>
        <p>Something went wrong.</p>
      </div>
    }
    return this.props.children
  }
}

export function ErrorSimulator () {
  throw new Error('Simulated error')
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js